const LOGIN_COMPLETED_SNACKBAR_KEY = "showLoginCompletedSnackbar";

export const LOGIN_COMPLETED_QUERY_PARAM = "loginCompleted";

export const markLoginCompletedSnackbar = () => {
  sessionStorage.setItem(LOGIN_COMPLETED_SNACKBAR_KEY, "1");
};

export const hasLoginCompletedSnackbar = (): boolean => {
  return sessionStorage.getItem(LOGIN_COMPLETED_SNACKBAR_KEY) === "1";
};

export const clearLoginCompletedSnackbar = () => {
  sessionStorage.removeItem(LOGIN_COMPLETED_SNACKBAR_KEY);
};

export const buildInternalRedirectUrl = (
  redirectUrl: string,
  token: string
): string => {
  const separator = redirectUrl.includes("?") ? "&" : "?";
  return `${redirectUrl}${separator}token=${encodeURIComponent(
    token
  )}&${LOGIN_COMPLETED_QUERY_PARAM}=1`;
};
